export default
{
    watch:
    {
        hour()
        {
            this.onChange();
        },

        minute()
        {
            this.onChange();
        },

        second()
        {
            this.onChange();
        },

        ampm()
        {
            this.onChange();
        },
    }
}
